import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule, FormArray  } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../../services/common-data.service';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-view-edit-product',
  templateUrl: './view-edit-product.component.html',
  styleUrls: ['./view-edit-product.component.css']
})
export class ViewEditProductComponent implements OnInit {

  
  modelForm: FormGroup;
  pageName = "Add New Product";
  modelName = "Product";

  localModelDataStorage = false;
  modelId = '0';
  modelData: any;
  returnData: any;
  files: any;
  dataReady = false

  filesToUpload: Array<File> = [];
  sizes: FormArray;

  step = "information"
  steps = {
    information : true,
    delivery: true,
    image: true,
    pricing: true,
    settings: true
  }

  constructor(
    //private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService
  ) {

    console.log(_data.queryParams);

    let queryData = new FormData();
    queryData.append('modelName', this.modelName);

    for (const [objectKey, value] of Object.entries(_data.queryParams)) {
      console.log(`${objectKey} ${value}`); // "a 5", "b 7", "c 9"

      queryData.append(`${objectKey}`, `${value}`);

    }

    $('#loader').show();
    //lets get the model for this page
  this._data.getModelData(queryData) 
  .pipe(first())
  .subscribe(
    data => {
      console.log(data);
      if(data['covers'].length > 0) {
        this.modelData = data['covers'][0]['cover']['model']['modelData']['formFieldsEntities'];
        this.modelId = data['covers'][0]['id'];
      }

      this.dataReady = true
      

    },
    error => {

        console.log(error);
        iziToast.success({
          title: 'Error!',
          position: 'topRight',
          icon: 'icon-circle-check',
          message: 'Failed to get product info.'
      });

      $('#loader').hide();
      this.dataReady = true

    },

    () => {
        $('#loader').hide();
    }
  );
  }

  ngOnInit() {

    $('#initialise-page').trigger('click');
    $('#owl-initialise').trigger('click');

  }

  stepCompleted(formDetails) {
    
      if(formDetails['step']) {
        this.steps[formDetails['step']] == true
      }

      if(formDetails['next']) {
        this.steps[formDetails['next']] == true
        this.step = formDetails['next']

        if(formDetails['next'] == 'complete') {
          this.router.navigate(['/sellers/account/products']);
        }
      }

      if(formDetails['dataModel'] && formDetails['modelId']) {
        this.modelData = formDetails['dataModel'];
        this.modelId = formDetails['modelId'];
      }
  }

  moveStep(current_step) {
    //current step 
      if(this.steps[current_step] == true) {
        this.step = current_step
      }
  }

  get f() { return this.modelForm.controls; }



}
